/* eslint-disable react-hooks/rules-of-hooks */
import { useContext, useEffect } from 'react'
import { useFunctions as useReactFireFunctions } from 'reactfire'
import firebaseContext from '../contexts/firebase/context'

const useFunctions = () => {
  const { addSdk, activeSDK } = useContext(firebaseContext)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      addSdk('functions')
    }
  }, [])
  return activeSDK.includes('functions') && useReactFireFunctions()
}

export default useFunctions
